module.exports = __webpack_public_path__ + "static/img/bg_coupon_on.09ca855.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/bg_coupon_on.png
// module id = CTkC
// module chunks = 1